import { render, staticRenderFns } from "./authorizationInfoModal.vue?vue&type=template&id=43b3ebb0&scoped=true"
import script from "./authorizationInfoModal.vue?vue&type=script&lang=js"
export * from "./authorizationInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b3ebb0",
  null
  
)

export default component.exports